<template>
  <div class="home">
    <h1>Home</h1>
    <button @click="logout()" >Logout</button>
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Home',
  components: {
  },
  mounted(){
   
  },
 methods:{
  logout(){
    localStorage.removeItem('access_token');
    this.$router.push('/')
  }
  }
}
</script>
